console.log("EPOPS chat loaded 🚀");

(() => {
    const lang = document.documentElement.lang?.startsWith("el") ? "el" : "en";

    const UI = {
        tipTitle: lang === "el" ?"Ρώτησε το ΕΠΟΨ ΑΙ" : "Ask the EPOPS AI",
        tipSubTitle: lang === "el" ?"Ο προσωπικός οδηγός σου για βιβλία, συγγραφείς & ιδέες." : "Your personal guide to books, authors & ideas.",
        title: lang === "el" ? "Ψηφιακός Οδηγός" : "Digital Guide",
        subtitle: lang === "el" ? "Ρωτήστε για βιβλία, συγγραφείς, ιδέες 🔍" : "Ask about books, authors & ideas 🔍",
        placeholder: lang === "el" ? "Κάνε μια ερώτηση..." : "Ask something...",
        send: lang === "el" ? "Αποστολή" : "Send",
        thinking: lang === "el" ? "Σκέφτομαι..." : "Thinking...",
        welcome: lang === "el"
            ? "Γεια σας! 👋 Είμαι ο ψηφιακός οδηγός των εκδόσεων ΕΠΟΨ. Μπορώ να σας προτείνω βιβλία, θεματικές ή συγγραφείς."
            : "Hello! 👋 I'm the EPOPS Publishing digital guide. I can recommend books, themes or authors."
    };

    const owlIcon = window.EPOPS_CHATBOT_ASSETS?.owl ?? "";

    function getIntroCopy() {
    const lang = document.documentElement.lang?.startsWith("el") ? "el" : "en";
    const path = window.location.pathname.toLowerCase();

    // Helpers
    const t = (elText, enText) => (lang === "el" ? elText : enText);

    // Page rules
    if (path.includes("/products/")) {
        return {
        title: t("Ρώτησε το <strong>ΕΠΟΨ AI</strong>", "Ask the Epops AI"),
        subtitle: t("Ρώτησε για αυτό το βιβλίο: θέμα, συγγραφέα, προτάσεις.", "Ask about this book: theme, author, recommendations.")
        };
    }

    if (path.includes("/collections/books") || path.includes("/collections/book")) {
        return {
        title: t("Βρες το επόμενο σου βιβλίο", "Find your next book"),
        subtitle: t("Πες μου τι σου αρέσει και θα σου προτείνω κάτι.", "Tell me what you like and I’ll suggest something.")
        };
    }

    if (path.includes("/pages/people")) {
        return {
        title: t("Ρώτησε για συγγραφείς", "Ask about authors"),
        subtitle: t("Βιογραφικά, έργα, θεματικές και προτάσεις.", "Bios, works, themes and recommendations.")
        };
    }

    if (path.includes("/blogs/") || path.includes("/pages/blog")) {
        return {
        title: t("Ρώτησε για ιδέες & άρθρα", "Ask about ideas & articles"),
        subtitle: t("Θέματα, έννοιες, συγγραφείς και προτεινόμενα βιβλία.", "Topics, concepts, authors and suggested books.")
        };
    }

    if (path.includes("/pages/verify")) {
        return {
        title: t("Χρειάζεσαι βοήθεια;", "Need help?"),
        subtitle: t("Ρώτησε για βιβλία/συγγραφείς όσο επαληθεύεις.", "Ask about books/authors while you verify.")
        };
    }

    // Default (Homepage / everything else)
    return {
        title: t("Ρώτησε το <strong>ΕΠΟΨ AI</strong>", "Ask the Epops AI"),
        subtitle: t("Ο ψηφιακός οδηγός σας για βιβλία & συγγραφείς.", "Your guide to books & authors.")
    };
    }

    const intro = getIntroCopy();
// <img src="//www.epopspublishing.com/cdn/shop/t/20/assets/EPOPS_LOGO.svg?v=58111562218925797211761204436" alt="Epops Logo" width="120"  height="auto" class="logo-img">
    document.getElementById("epops-chat-root").innerHTML = `
        <div id="epops-intro-wrapper">
            <div id="epops-intro-owl"><img src="${owlIcon}" /></div>
            <div id="epops-intro-tip">
                <div class="tip-title">${intro.title}</div>
                <div class="tip-subtitle">${intro.subtitle}</div>
            </div>
        </div>

        <div id="epops-panel">
            <header>
                <div class="header-left">
                    
                    <img class="logo-img" src="${owlIcon}" />
                    <strong>Βοηθός ΑΙ ΕΠΟΨ</strong><span style="font-size: 14px;">powered by <strong style="font-size:18px; padding-left:0px;">GaiaB</strong></span>
                </div>

                <div class="epops-header-actions">
                    <span id="epops-fullscreen">⛶</span>
                    <span id="epops-clear">🗑</span>
                    <span id="epops-close"><strong>×</strong></span>
                </div>
            </header>
            <div id="epops-messages"></div>
            <div id="epops-input-area">
                <input id="epops-input" type="text" placeholder="${UI.placeholder}">
                <button id="epops-send">${UI.send}</button>
            </div>
        </div>
    `;

    // Elements
    const panel = document.getElementById("epops-panel");
    const fullscreenBtn = document.getElementById("epops-fullscreen");
    const close = document.getElementById("epops-close");
    const msgBox = document.getElementById("epops-messages");
    const input = document.getElementById("epops-input");
    const sendBtn = document.getElementById("epops-send");
    const clearBtn = document.getElementById("epops-clear");

    const introWrapper = document.getElementById("epops-intro-wrapper");
    const introOwl = document.getElementById("epops-intro-owl");
    const introTip = document.getElementById("epops-intro-tip");

    // CHIPS
    document.querySelectorAll(".epops-suggestions button").forEach(btn => {
        btn.onclick = () => {
            input.value = btn.dataset.prompt;
            sendMessage();
            btn.parentElement.remove(); // remove chips after first use
        };
    });

    // Fullscreen
    fullscreenBtn.addEventListener("click", () => {
        const isFullscreen = panel.classList.toggle("fullscreen");

        // Icon swap
        fullscreenBtn.textContent = isFullscreen ? "🗗" : "⛶";

        // Prevent body scroll when expanded
        document.body.style.overflow = isFullscreen ? "hidden" : "";
    });

    let chatHistory = [];
    let historyLoaded = false;
    let welcomedBack = false;
    let owlIsDetached = false;

    function detachOwlToBubble() {
        if (owlIsDetached) return;
        owlIsDetached = true;

        const owl = introOwl.querySelector("img");

        const finalBubble = document.createElement("div");
        finalBubble.id = "epops-owl-bubble";
        finalBubble.appendChild(owl);

        // Insert bubble *without* animation first
        finalBubble.style.opacity = "0";
        finalBubble.style.transform = "translateY(-40px)";
        document.body.appendChild(finalBubble);
        introWrapper.remove();

        finalBubble.onclick = openChat;

        // Wait for next frame → THEN trigger CSS animations
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                finalBubble.style.opacity = "";
                finalBubble.style.transform = "";
                finalBubble.classList.add("animate"); 
            });
        });
    }

    function collapseIntro() {
        introTip.style.opacity = "0";
        introTip.style.transform = "translateY(30px)";

        introOwl.style.transition = "all .45s ease";
        introOwl.style.transform = "translateY(90px)";

        setTimeout(detachOwlToBubble, 450);
    }

    let dismissed = false;
    const SCROLL_THRESHOLD = 150;
    window.addEventListener("scroll", () => {
        if (!dismissed && window.scrollY >= SCROLL_THRESHOLD) {
            dismissed = true;
            collapseIntro();
        }
    });

    function openChat() {
        collapseIntro();
        panel.classList.add("opened");
        // showSuggestionChips();
        // 🔒 Load history ONCE
        if (!historyLoaded) {
            historyLoaded = true;

            const stored = JSON.parse(
                localStorage.getItem("epops_chat_history") || "[]"
            );

            if (stored.length > 0) {
                for (let m of stored) {
                    if (m?.text && m?.from) {
                        chatHistory.push(m);
                        addMessage(m.text, m.from);
                    }
                }

                // 👋 Welcome back (once)
                if (!welcomedBack) {
                    welcomedBack = true;
                    setTimeout(() => {
                        addMessage(
                            lang === "el"
                                ? "Καλωσήρθατε πίσω!👋 Πώς μπορώ να βοηθήσω; 😊"
                                : "Welcome back!👋 How can I help? 😊",
                            "bot", { showAvatar: true }
                        );
                    }, 1200);
                }
            } else {
                addMessage(UI.welcome, "bot", { showAvatar: true });
                showSuggestionChips();
            }
        }
    }

    close.onclick = () => {
        panel.classList.remove("opened", "fullscreen");
        document.body.style.overflow = "";
    };

    function formatTime(date = new Date()) {
        return date.toLocaleString(lang === "el" ? "el-GR" : "en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit"
        });
    }

    function clearLastTimestamp() {
        msgBox.querySelectorAll(".msg-time").forEach(t => t.remove());
    }
    function removeAllBotAvatars() {
        document.querySelectorAll(".bot-avatar").forEach(el => el.remove());
    }

    function addMessage(text, from = "bot", opts = {}) {
        const { showAvatar = false, isTyping =  false, isThinking = false } = opts;

        clearLastTimestamp();

        const row = document.createElement("div");
        row.className = `msg-row ${from}-row`;

        const col = document.createElement("div");
        col.className = "msg-col";

        const time = document.createElement("div");
        time.className = "msg-time";
        time.textContent = formatTime();

        if (from === "bot") {
            removeAllBotAvatars();
            // ✅ only show avatar if explicitly requested
            if (showAvatar) {
            const avatar = document.createElement("img");
            avatar.src = window.EPOPS_CHATBOT_ASSETS?.botIcon || owlIcon;
            avatar.className = "bot-avatar";
            row.appendChild(avatar);
            } else {
            // keep alignment (optional)
            const spacer = document.createElement("div");
            spacer.className = "bot-avatar hidden";
            row.appendChild(spacer);
            }

            const bubble = document.createElement("div");
            bubble.className = "bot" + (isTyping ? " typing" : " bot-animate") + (isThinking ? " thinking" : "");
            bubble.textContent = text;

            if (isTyping) bubble.dataset.typing = "1";
            col.appendChild(bubble);
            col.appendChild(time);
            row.appendChild(col);
        } else {
            const bubble = document.createElement("div");
            bubble.className = "user";
            bubble.textContent = text;

            col.appendChild(bubble);
            col.appendChild(time);
            row.appendChild(col);
        }

        msgBox.appendChild(row);
        msgBox.scrollTop = msgBox.scrollHeight;
    }

    function streamBotReply(text) {
        const div = document.createElement("div");
        div.className = "bot bot-animate";
        msgBox.appendChild(div);

        const words = text.split(" ");
        let i = 0;

        const interval = setInterval(() => {
            div.textContent += (i === 0 ? "" : " ") + words[i];
            msgBox.scrollTop = msgBox.scrollHeight;
            i++;

            if (i >= words.length) {
            clearInterval(interval);
            }
        }, 35); // adjust speed (30–50ms feels great)

        // optional sound (when allowed by browser)
        if (botSound) {
            botSound.cloneNode().play().catch(() => {});
        }
    }

    // const API_URL = "https://epops-service.onrender.com/chat";
    const API_URL = "https://epopsapi.informservices.gr:62637/chat-dry-run";

    async function sendMessage() {
        const text = input.value.trim();
        if (!text) return;

        addMessage(text, "user");
        input.value = "";

        chatHistory.push({ text, from: "user" });
        localStorage.setItem("epops_chat_history", JSON.stringify(chatHistory));
        addMessage(UI.thinking, "bot", { showAvatar: true, isTyping: true, isThinking: true });
        // const thinking = document.createElement("div");
        // thinking.className = "bot typing";
        // thinking.innerHTML = UI.thinking;
        // msgBox.appendChild(thinking);

        msgBox.scrollTop = msgBox.scrollHeight;

        try {
            const resp = await fetch(API_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ question: text, history: chatHistory })
            });

            const result = await resp.json().catch(() => ({}));
            // thinking.remove();
            removeThinkingBubble();

            // const errorText = lang === "el"? "⚠ Η υπηρεσία δεν είναι διαθέσιμη αυτή τη στιγμή.": "⚠ The service is currently unavailable.";

            const reply = result.reply || "⚠ No response from server";
            // if (reply === "⚠ GaiaB unreachable") reply = errorText;
            console.log(reply);
            addMessage(reply, "bot", { showAvatar: true, isTyping: true, isThinking: false });
            // streamBotReply(reply);

            chatHistory.push({ text: reply, from: "bot" });
            localStorage.setItem("epops_chat_history", JSON.stringify(chatHistory));

        } catch {
            removeThinkingBubble();

            // const errorText =
            //     lang === "el"
            //         ? "⚠ Η υπηρεσία δεν είναι διαθέσιμη αυτή τη στιγμή."
            //         : "⚠ The service is currently unavailable.";

            // // // 👇 SHOW error as bot message (with avatar + time)
            // // addMessage(errorText, "bot", {
            // //     showAvatar: true,
            // //     isTyping: false
            // // });

            // chatHistory.push({ text: errorText, from: "bot" });
            // localStorage.setItem("epops_chat_history", JSON.stringify(chatHistory));
        }
    }

    function removeThinkingBubble() {
        msgBox.querySelector(".bot.thinking")?.closest(".msg-row")?.remove();
    }

    sendBtn.onclick = sendMessage;
    input.addEventListener("keydown", e => {
    if (e.key === "Enter") {
        sendMessage();
    }
    });

    clearBtn.onclick = () => {
        localStorage.removeItem("epops_chat_history");
        chatHistory = [];
        historyLoaded = true;
        welcomedBack = false;
        msgBox.innerHTML = "";
        addMessage(UI.welcome, "bot", { showAvatar: true });

        showSuggestionChips();
    };

    introOwl.onclick = openChat;

    input.addEventListener("focus", () => {
    console.log("INPUT FOCUSED ✅");
    });

    // CHIPS
    function getSuggestionsHTML() {
    const isGR = document.documentElement.lang?.startsWith("el");

    // You can also make these page-aware if you want (using getIntroCopy/path)
    const chips = isGR
        ? [
            { label: "Βιβλία ιστορίας", prompt: "Πρότεινέ μου ένα βιβλίο ιστορίας" },
            { label: "Γεωπολιτική",     prompt: "Πρότεινέ μου ένα βιβλίο για γεωπολιτική" },
            { label: "Οικονομία",       prompt: "Ποια βιβλία έχετε για την οικονομία;" },
            { label: "Ποίηση",          prompt: "Ποια βιβλία έχετε για ποίηση;" },
            { label: "Συγγραφείς",      prompt: "Ποιοι είναι οι συγγραφείς του ΕΠΟΨ;" },
            { label: "ΕΠΟΨ",            prompt: "Πες μου μερικά πράγματα για τον ΕΠΟΨ;" }
        ]
        : [
            { label: "History",     prompt: "Recommend me a history book" },
            { label: "Geopolitics", prompt: "Recommend me a geopolitics book" },
            { label: "Economy",     prompt: "What books do you have about economics?" },
            { label: "Poetry",      prompt: "What poetry books do you have?" },
            { label: "Authors",     prompt: "Who are the EPOPS authors?" },
            { label: "EPOPS",       prompt: "Tell me something for EPOPS?" },
        ];

    return `
        <div class="epops-suggestions">
        ${chips
            .map(
            c =>
                `<button type="button" data-prompt="${escapeHtml(c.prompt)}">${escapeHtml(c.label)}</button>`
            )
            .join("")}
        </div>
    `;
    }

    function bindSuggestionChips() {
    document.querySelectorAll(".epops-suggestions button").forEach(btn => {
        btn.onclick = () => {
        input.value = btn.dataset.prompt || "";
        sendMessage();
        btn.closest(".epops-suggestions")?.remove(); // optional: remove after first use
        };
    });
    }

    function showSuggestionChips() {
    // remove existing chips first (avoid duplicates)
    msgBox.querySelector(".epops-suggestions")?.remove();

    msgBox.insertAdjacentHTML("beforeend", getSuggestionsHTML());
    bindSuggestionChips();
    }

    function escapeHtml(str) {
    return String(str)
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#039;");
    }

    // Escape logic
    document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;

    // Don't close while typing in inputs/textareas or editable areas
    const el = document.activeElement;
    const typing =
        el &&
        (el.tagName === "INPUT" ||
        el.tagName === "TEXTAREA" ||
        el.isContentEditable);

    if (typing) return;

    // 1) If fullscreen -> exit fullscreen
    if (panel.classList.contains("fullscreen")) {
        panel.classList.remove("fullscreen");
        fullscreenBtn.textContent = "⛶";
        document.body.style.overflow = "";
        return;
    }

    // 2) Else if opened -> close panel
    if (panel.classList.contains("opened")) {
        // use your existing close function if you have one
        if (typeof closeEpopsPanel === "function") {
        closeEpopsPanel();
        } else {
        panel.classList.remove("opened");
        document.body.style.overflow = "";
        }
    }
    });
})();
